import Tooltip from '../../../Utils/Tooltip';
import { useIntl } from 'react-intl';
import Clipboard from 'react-clipboard.js';
import Notification from '../../../Utils/Notification';
import iconCopy from '../../../../icons/icon-copy.svg';

const Input = ({ placeholder, label, tooltip, type = 'text', value, hasCopy = false, ref, onChange, dataValue, validated = true }) => {
  const { formatMessage } = useIntl();
  const onCopy = () => {
    Notification({
      type: 'success',
      text: formatMessage({ id: 'Text has been copied' }),
    }).show();
  };

  return (
    <div className='integration__input'>
      {label && (
        <label>
          {label &&
            formatMessage(
              {
                id: label,
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>,
              }
            )}
        </label>
      )}
      {tooltip ? (
        <span>
          <Tooltip
            placement='top'
            message={formatMessage({
              id: tooltip,
            })}
          />
        </span>
      ) : null}

      <div className={`integration__input--wrapper ${!validated ? 'integration__input--errorShadow' : ''}`}>
        <input
          ref={ref}
          type={type}
          placeholder={placeholder && formatMessage({ id: placeholder })}
          data-value={dataValue}
          value={value}
          onChange={onChange}
        />

        {hasCopy && (
          <Clipboard component='a' data-clipboard-text={value} onSuccess={onCopy}>
            <img src={iconCopy} className='icon' alt='' />
          </Clipboard>
        )}
      </div>
    </div>
  );
};

export default Input;
